<template>
  <li :class="{'mobile-table-section': true, 'seperator-lines': seperatorLines}">
    <slot />
  </li>
</template>

<style lang="scss" scoped>
$sectionHeight: 30px;

li.mobile-table-section {
  position: relative;
  height: $sectionHeight;
  list-style-position: outside;
  list-style-type: none;
  font-size: 1.1rem;
  line-height: 1.2rem;
  font-weight: 600;
  color: #878a8c;
  padding: 6px 4px 6px 4px;
  vertical-align: middle;
  overflow: hidden;
}
li.mobile-table-section.seperator-lines {
  border-bottom: 1px solid #e7e7e7;
}
li.mobile-table-section:not(:first-child) {
  margin-top: 8px;
}
</style>

<script>
export default {
  name: 'MobileTableSectionHeader',
  props: {
    seperatorLines: {
      type: Boolean,
      default: true
    },
  }
}
</script>